import { render, staticRenderFns } from "./SubtaskInfo.vue?vue&type=template&id=f5ea19ac&"
import script from "./SubtaskInfo.vue?vue&type=script&lang=js&"
export * from "./SubtaskInfo.vue?vue&type=script&lang=js&"
import style0 from "./SubtaskInfo.vue?vue&type=style&index=0&id=f5ea19ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports